import get from 'lodash.get';
import getIsB2C from './is-b2c';

const getLegacyTemplateGalleryUrl = (rootState) => {
  if (getIsB2C(rootState)) {
    return get(rootState, 'config.common.templategallery.url');
  }

  return get(rootState, 'config.common.templategallery.wl_url');
};

export default getLegacyTemplateGalleryUrl;
